import { render, staticRenderFns } from "./ValidacionBin.vue?vue&type=template&id=2c56da02&scoped=true"
import script from "./ValidacionBin.vue?vue&type=script&lang=js"
export * from "./ValidacionBin.vue?vue&type=script&lang=js"
import style0 from "./ValidacionBin.vue?vue&type=style&index=0&id=2c56da02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56da02",
  null
  
)

export default component.exports